import useSelector from "./useSelector";
import { DocumentType as RailDocumentType } from "shared/models/site/document-type";


export const useAllDocumentTypes = () => (useSelector(s => s.railDocumentTypes) || []);

export default (key: string): RailDocumentType | undefined => {
    key = key.replace(/\s/g, '').toLowerCase();
    var selector = useSelector(s => s.railDocumentTypes);

    if (!selector) {
        return;
    }

    //Select a type where the type or subtype matches the key
    var type = (selector || []).filter(x => x.key === key || x.children?.filter(x => x.key === key)[0]?.key == key)[0];

    //If the child of the selected type matches the key, return the child instead
    if (type?.children?.filter(x => x.key === key)[0]?.key == key) {
        return type?.children?.filter(x => x.key === key)[0];
    }

    //Return the main selected type
    return type;
}

